import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import { RichText as PrismicRichText } from "prismic-reactjs"

import Column from "./Column"
import { Element, Text } from "legacy/components/shared/base"
import Grid from "legacy/components/shared/Grid"
import { Maybe } from "types/Maybe"
import {
  PrismicPageDataBodyRecentPosts,
  RecentPostsQuery,
} from "types/__generated__/gatsby-graphql"

interface OwnProps {
  data: Maybe<PrismicPageDataBodyRecentPosts>
}

export type RecentPostsProps = OwnProps

const RecentPosts: React.FC<RecentPostsProps> = ({
  data,
}): React.ReactElement | null => {
  const posts = useStaticQuery<RecentPostsQuery>(graphql`
    query RecentPosts {
      allPrismicBlogPost(sort: { data: { publish_date: DESC } }) {
        edges {
          node {
            id
            uid
            url
            data {
              body {
                ... on PrismicBlogPostDataBodyHero {
                  id
                  primary {
                    post_subtitle {
                      html
                      richText
                      text
                    }
                    post_title {
                      richText
                      html
                      text
                    }
                  }
                }
              }
              og_image {
                alt
                dimensions {
                  height
                  width
                }
                url
              }
              publish_date
            }
          }
        }
      }
    }
  `)

  const headline = data?.primary?.headline
  const repeater = posts.allPrismicBlogPost.edges

  return (
    <Element>
      <Element
        m="0 auto"
        maxWidth="1440px"
        p={["40px 20px", "80px 8%", "120px 8%", "120px 8% 105px"]}
      >
        {headline ? (
          <Text
            as="h1"
            fontSize={["36", "text.headerLarge"]}
            lineHeight={["44px", "1.4"]}
            m={["0 auto 30px", "0 0 75px", "0 0 95px"]}
            maxWidth={["350px", "none"]}
            textAlign="center"
            variant="headerLarge"
          >
            {PrismicRichText.asText(headline.richText)}
          </Text>
        ) : null}
        <Grid gridTemplateColumns={["", "2col", "2col", "3col"]}>
          {repeater.length > 0
            ? repeater.map((item, index) => {
                return (
                  <Column
                    data={item?.node?.data}
                    key={`column_${index}`}
                    url={item?.node?.url}
                  />
                )
              })
            : null}
        </Grid>
      </Element>
    </Element>
  )
}

export default RecentPosts
